// ---------------------------------------------
// Navigation Module - DeSight Shopify Theme
// ---------------------------------------------
// Navigations-Funktionalität
// ---------------------------------------------

import { $, $$, debounce } from '../utils/helpers.js';

/**
 * Custom Navigation Funktionen
 */
export class CustomNavigation {
  constructor() {
    this.header = $('header');
    this.lastScrollTop = 0;
    this.init();
  }

  init() {
    this.initStickyHeader();
  }

  /**
   * Sticky Header Funktionalität
   */
  initStickyHeader() {
    if (!this.header) return;

    let hasScrolled = false;

    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (!hasScrolled && scrollTop > 160) {
        hasScrolled = true;
        this.header.classList.add('is-scrolled');
      } else if (hasScrolled && scrollTop <= 160) {
        hasScrolled = false;
        this.header.classList.remove('is-scrolled');
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
  }
}

